// captions/languages.ts — the caption languages the composer offers (1.27.60). Codes are
// what the server stores (BCP 47 short) and what the speech model understands.
export const CAPTION_LANGUAGES: { code: string; label: string }[] = [
  { code: 'en', label: 'English' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'zh', label: '中文' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'ar', label: 'العربية' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'de', label: 'Deutsch' },
  { code: 'pt', label: 'Português' },
  { code: 'ru', label: 'Русский' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'th', label: 'ไทย' },
  { code: 'tl', label: 'Filipino' },
];

export function captionLanguageLabel(code: string): string {
  return CAPTION_LANGUAGES.find((l) => l.code === code)?.label ?? code;
}

/** The browser's language when we offer it, else English. */
export function defaultCaptionLanguage(): string {
  const primary = (typeof navigator !== 'undefined' ? navigator.language : 'en')
    .split('-')[0]!
    .toLowerCase();
  return CAPTION_LANGUAGES.some((l) => l.code === primary) ? primary : 'en';
}
